import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ButtonSecondary } from '@americanexpress/dls-react';
import NoResultsMessage from './NoResultsMessage';

const NoResultsPage = ({ onTryAgain }) => {
  const intl = useIntl();

  return (
    <div>
      <NoResultsMessage
        heading={intl.formatMessage({
          id: 'search.page.no.results.heading',
          defaultMessage: "We're Sorry",
        })}
        message={intl.formatMessage({
          id: 'search.page.no.results',
          defaultMessage:
            'We are unable to locate your application - either your Social Security Number and/or Home Zip Code do not match our records or our system has not been updated with your application information. Please note that our system is updated every 24 hours. You may want to bookmark this page and try again tomorrow. Or, if you prefer, you can call us at 1-866-314-0237 (Mon-Fri 6am-8pm MST) to check the status of your application by phone.',
        })}
      />
      <div className="pad-3-t" style={{ textAlign: 'center' }}>
        <ButtonSecondary size="sm" onClick={onTryAgain}>
          {intl.formatMessage({
            id: 'search.page.no.results.try.again',
            defaultMessage: 'Try Again',
          })}
        </ButtonSecondary>
      </div>
    </div>
  );
};

NoResultsPage.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
};

export default NoResultsPage;
